import { defineComponent as _defineComponent } from 'vue'
import { timeAgo } from "@/shared";


// props
interface IProps {
	timestamp: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TimeAgo',
  props: {
    timestamp: null
  },
  setup(__props: any) {



return { __sfc: true,timeAgo }
}

})